import netWorkController from "@/http/netWorkController";
import cookieUtils from "@/utils/cookieUtils";
import toastUtils from "@/utils/toastUtils";
import dateUtils from "@/utils/dateUtils";
import logLevelUtils from "@/utils/logLevelUtils";

export default {
    name: "HistoryOnlineLogPage",
    data() {
        return {
            logLevel: logLevelUtils.logLevelList(),
            appList: [],
            requestForm: {
                appId: -1,
                ///当前页数
                pageNum: 1,
                ///一页总数
                pageSize: 10,
                ///总条数
                total: 0,
                logLevel: -1
            },
            onLineLogList: [],
            date: null
        }
    },
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.userInfo = JSON.parse(userInfoStr)
            this.requestForm.userId = this.userInfo.id;
            netWorkController.appList(this.userInfo.id, this.userInfo.accessToken, (result) => {
                if (result.data) {
                    this.appList = result.data
                    let appIdCache = cookieUtils.get("appIdCache")
                    if (appIdCache) {
                        this.requestForm.appId = Number.parseInt(appIdCache);
                    } else {
                        this.requestForm.appId = this.appList[0].id
                    }
                    this.historyOnLineLog()
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        }
    },
    methods: {
        historyOnLineLog() {
            if (this.date && this.date.length > 0) {
                this.requestForm.logBeginTime = dateUtils.dateToTimestamp(this.date[0])
                this.requestForm.logEndTime = dateUtils.dateToTimestamp(this.date[1])
            } else {
                this.requestForm.logBeginTime = null
                this.requestForm.logEndTime = null
            }
            netWorkController.historyOnLineLog(this.requestForm, (result) => {
                if (result.status === 200) {
                    this.onLineLogList = result.data.list
                    this.requestForm.total = result.data.total
                    this.requestForm.pageSize = result.data.pageSize
                    this.requestForm.pageNum = result.data().pageNum
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        getStyle(logLevel) {
            let extColor = logLevelUtils.logLevelColorExchange(logLevel)
            return 'white-space: break-spaces; color:' + extColor + ' ;'
        },
        formatLevel(cellValue) {
            return logLevelUtils.logLevelExchange(cellValue)
        },
        formatDate(cellValue) {
            return dateUtils.timestampToDate(cellValue);
        },
        onchange(value) {
            cookieUtils.set("appIdCache", value);
            this.historyOnLineLog();
        },
        handleSizeChange(value) {
            if (value) {
                this.requestForm.pageSize = value
                this.historyOnLineLog()
            }
        },
        handleCurrentChange(value) {
            if (value) {
                this.requestForm.pageNum = value;
                this.historyOnLineLog()
            }
        },
        ///日志等级切换，分页自动回到第一页
        levelChange() {
            this.requestForm.pageNum = 1;
        }
    }

}